export default __webpack_public_path__ + "static/pole-1-thumb-ad57fc68eafa42c187b92a9deb3f9207.png";